/* src/app/front-layout/upcoming-events/upcoming-events.component.css */
/*# sourceMappingURL=upcoming-events.component.css.map */
